// accordion js function start
const allAccordionsElToOpenOnInit = document.querySelectorAll(
  "[custom-data-accordion-open-on-load]",
);
const allAccordions = document.querySelectorAll("[custom-data-accordion]");

const handleAccordion = function (e) {
  const accordion = this;
  const accordionBody = accordion.querySelector("[custom-data-accordionBody]");

  if (accordion.classList.contains("accordion_open")) {
    accordionBody.style.maxHeight = "0px";
    // remove open class on accordion element
    accordion.classList.remove("accordion_open");
    accordion.setAttribute("aria-expanded", false);
  } else {
    // close the open accordion first
    const accrdionOpenEl =
      accordion
        .closest("[custom-data-accordions]")
        .querySelector(".accordion_open") || null;
    if (accrdionOpenEl) {
      accrdionOpenEl.click();
    }

    accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";

    // add open class on accordion element
    accordion.classList.add("accordion_open");
    accordion.setAttribute("aria-expanded", true);
  }
};

allAccordions.forEach((accordion) => {
  accordion.addEventListener("click", handleAccordion);

  accordion.addEventListener("keydown", function (e) {
    if (e.target.hasAttribute("href")) return;
    e.stopPropagation();
    if (
      e.keyCode === 13 ||
      e.key === "Enter" ||
      e.keyCode === 32 ||
      e.key === " "
    ) {
      // The Enter key or Spacebar was pressed, so trigger your action here
      e.preventDefault(); // Prevent any default action (e.g., form submission)
      handleAccordion.call(this, e);
      // Your code to handle the Enter or Spacebar key press goes here
    }
  });
});

// set accordion as open where elements have this data attr '[custom-data-accordion-open-on-load]'
allAccordionsElToOpenOnInit.forEach((accordion) => {
  const accordionBody = accordion.querySelector("[custom-data-accordionBody]");

  // toggle class on accordion element
  accordion.classList.add("accordion_open");

  accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
});

// accordion js function end

document.addEventListener('DOMContentLoaded', function() {
  // Get all open modal buttons
  const openModalButtons = document.querySelectorAll('.open-modal');
  
  // Get all modals
  const modals = document.querySelectorAll('.custom__modal');
  
  // Get all close buttons
  const closeModalButtons = document.querySelectorAll('.close-modal');

  // Open the modal when button is clicked
  openModalButtons.forEach(button => {
    button.addEventListener('click', function() {
      const modalId = this.getAttribute('data-modal-id');
      const modal = document.querySelector(`#${modalId}`);
      if (modal) {
        modal.classList.add('active'); // Slide modal up
      }
    });
  });

  // Close the modal when close button is clicked
  closeModalButtons.forEach(button => {
    button.addEventListener('click', function() {
      const modal = this.closest('.custom__modal');
      modal.classList.remove('active'); // Slide modal down
    });
  });

  // Close the modal when clicking outside the modal content
  modals.forEach(modal => {
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.classList.remove('active');
      }
    });
  });
});

